import React, { useState } from 'react';
import { api } from '../lib/api.js';
import { inr } from '../lib/format.js';
import { openWhatsApp, preopenWindow } from '../lib/whatsapp.js';

/**
 * Chasing one customer: a WhatsApp message with what is due, or the same as an
 * e-mail through the outbox. Both say what is outstanding and, where Tally's
 * bills are known, which ones are overdue.
 */
export default function ReminderActions({ party }) {
  const [busy, setBusy] = useState(null);
  const [note, setNote] = useState(null);
  const [error, setError] = useState(null);

  const whatsapp = async () => {
    setBusy('wa'); setError(null); setNote(null);
    const win = preopenWindow();
    try {
      const r = await api.get(`/api/reports/receivables/${party.party_id}/reminder`);
      if (!r.whatsapp_enabled) {
        if (win) win.close();
        setError('WhatsApp is switched off for this company. An administrator can turn it on in Settings.');
        return;
      }
      openWhatsApp(r.phone, r.text, win);
      if (!r.phone) setNote('No mobile number on record: pick the chat in WhatsApp. Add the number under Customers.');
    } catch (e) {
      if (win) win.close();
      setError(e.message);
    } finally { setBusy(null); }
  };

  const email = async () => {
    setBusy('mail'); setError(null); setNote(null);
    try {
      const r = await api.post(`/api/reports/receivables/${party.party_id}/remind`, {});
      setNote(`Reminder queued for ${r.to}. It goes out with the outbox once mail is set up under Settings.`);
    } catch (e) { setError(e.message); } finally { setBusy(null); }
  };

  return (
    <div className="inline" style={{ gap: 8, flexWrap: 'wrap' }}>
      <span className="sub">
        {inr(party.outstanding, 0)} outstanding{party.overdue > 0 ? `, ${inr(party.overdue, 0)} overdue` : ''}
        {party.phone ? ` · ${party.phone}` : ''}{party.email ? ` · ${party.email}` : ''}
      </span>
      <button className="btn small secondary" disabled={busy !== null || party.outstanding <= 0} onClick={whatsapp}>
        {busy === 'wa' ? 'Opening…' : 'Remind on WhatsApp'}
      </button>
      <button className="btn small secondary" disabled={busy !== null || !party.email || party.outstanding <= 0} onClick={email}
        title={party.email ? undefined : 'Add an e-mail address under Customers first'}>
        {busy === 'mail' ? 'Queueing…' : 'E-mail a reminder'}
      </button>
      {note && <span className="sub">{note}</span>}
      {error && <span className="sub" role="alert" style={{ color: 'var(--critical-text)' }}>{error}</span>}
    </div>
  );
}
